import { metricsBus } from "buses";
import microsoftClarity from "services/microsoftClarity/microsoftClarity";

metricsBus.on("userFetched", ({ user }) => microsoftClarity.setUserName(user.username));

metricsBus.on("deviceTracked", ({ deviceId }) => microsoftClarity.setDeviceId(deviceId));
